import { Component, signal, inject } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";

import { VersionService } from "services/version.service";

@Component({
  selector: "app-version-sync-banner",
  standalone: true,
  imports: [TranslateModule],
  templateUrl: "./version-sync-banner.component.html",
  styleUrls: ["./version-sync-banner.component.scss"],
})
export class VersionSyncBannerComponent {
  private readonly versionService = inject(VersionService);

  readonly isVersionOutOfDate = signal(false);

  public checkVersion() {
    this.versionService.checkVersionWithBackend().subscribe((result) => {
      this.isVersionOutOfDate.set(result === false);
    });
  }
}
